import './ReactCustomTable.css';
import { Fragment } from 'react';
import { CircularProgress } from '@mui/material';
import { Table, Pagination } from 'rsuite';
import "rsuite/dist/rsuite.min.css";

const { Column, HeaderCell, Cell } = Table;

function ReactCustomTable({
    data, tableColumns, loading, tableActions, actionsColumnWidth, onRowClick, circularColor,
    deleteID, deleteLoading, rowDataDeleteKey,  // Delete
    downloadId, downloadLoading, //Loading
    total, limit, activePage, onChangePage, onChangeLimit // Pagination props
}) {
    return (
        <div style={{ padding: '0 0 20px 0' }}>
            <Table
                height={500}
                // fillHeight
                virtualized
                data={data}
                loading={loading}
                onRowClick={onRowClick ? rowData => onRowClick(rowData) : () => { }}
            >
                {tableColumns?.map((c, index) => (
                    <Column width={c?.width} fixed={c?.fixed} flexGrow={c?.flexGrow} align={c?.align || 'left'} fullText={c?.fullText}
                        resizable={!c?.flexGrow} minWidth={c?.minWidth} key={index}
                    >
                        <HeaderCell>{c?.label}</HeaderCell>
                        {c?.cell ? (
                            <Cell>{rowData => c.cell(rowData)}</Cell>
                        ) : c?.key === 'idcard_status' ? (
                            <Cell>
                                {rowData => {
                                    const status = rowData?.idcard_status || 'Not Created';
                                    let bgColor = '#f5f5f5';
                                    let textColor = '#666';
                                    if (status === 'Downloaded') {
                                        bgColor = '#e8f5e9';
                                        textColor = '#2e7d32';
                                    } else if (status === 'Verified') {
                                        bgColor = '#e3f2fd';
                                        textColor = '#1565c0';
                                    } else if (status === 'Pending') {
                                        bgColor = '#fff3e0';
                                        textColor = '#e65100';
                                    } else if (status === 'Not Created') {
                                        bgColor = '#ffebee';
                                        textColor = '#c62828';
                                    }
                                    return (
                                        <span style={{
                                            backgroundColor: bgColor,
                                            color: textColor,
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            display: 'inline-block'
                                        }}>
                                            {status}
                                        </span>
                                    );
                                }}
                            </Cell>
                        ) : (
                            <Cell dataKey={c?.key} />
                        )}
                    </Column>
                ))}

                {tableActions && (
                    <Column width={actionsColumnWidth} fixed="right" align='center' resizable minWidth={200}>
                        <HeaderCell>Actions</HeaderCell>

                        <Cell>
                            {rowData => (
                                <div className='rsuite_actions_btnCont' >
                                    {tableActions?.map((t, i) => {
                                        if (t?.btnType === 'del' && rowData?.role === 'teacher') {
                                            return null;
                                        }
                                        return (
                                            <Fragment key={i}>
                                                {t?.btnType == 'download' ? (
                                                    <>
                                                        {rowData[rowDataDeleteKey] == downloadId && downloadLoading ? (
                                                            <CircularProgress size={18} style={{ color: 'darkgreen', marginRight: 10 }} />
                                                        ) : (
                                                            <div onClick={(e) => t.onClick(e, rowData)} >
                                                                {t?.icon}
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {rowData[rowDataDeleteKey] == deleteID && deleteLoading && t?.btnType == 'del' ? (
                                                            <CircularProgress size={18} style={{ color: circularColor, marginRight: 10 }} />
                                                        ) : (
                                                            <div onClick={(e) => t.onClick(e, rowData)} >
                                                                {t?.icon}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </Fragment>
                                        );
                                    })}
                                </div>
                            )}
                        </Cell>
                    </Column>
                )
                }
            </Table >
            <div style={{ padding: 20 }}>
                <Pagination
                    prev
                    last
                    next
                    first
                    size="md"
                    total={total !== undefined ? total : (data ? data.length : 0)}
                    limit={limit || 10}
                    limitOptions={[10, 25, 50]}
                    maxButtons={10}
                    activePage={activePage || 1}
                    onChangePage={onChangePage}
                    onChangeLimit={onChangeLimit}
                    layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                />
            </div>
        </div>
    )
}

export default ReactCustomTable;
